import React, { Component } from "react";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import "components/widgets/training/Training.css";
import { Trans } from "react-i18next";
import i18n from "i18next";

class EmployeeTraining extends Component {
    state = {
        showingChildren: false,
    };

    languageCode = this.props.languageCode;

    renderTrainingMethodIcon = (value) => {
        switch (value) {
            case 3:
                return (
                    <td>
                        <span className="iconmford fo-icon-tv ">
                            <span className="path1"></span>
                            <span className="path2"></span>
                            <span className="path3"></span>
                            <span className="path4"></span>
                        </span>
                    </td>
                );
            case 1:
                return (
                    <td>
                        <span className="iconmford fo-icon-live-tv"></span>
                    </td>
                );
            default:
                return (
                    <td>
                        <span className="iconmford fo-icon-class "></span>
                    </td>
                );
        }
    };

    renderTabletModeDetail = (t) => {
        if (!this.state.showingChildren) {
            return null;
        }
        return (
            <tr className="child">
                <td className="child" colSpan="2">
                    <table>
                        <tbody>
                            <tr data-dt-row="0" data-dt-column="2">
                                <td>
                                    <div className="tableTitle">
                                        <Trans desc="Eğitim Metodu">10712</Trans>
                                    </div>
                                </td>
                                <td className="showGrup">{t.trainingMethod}</td>
                            </tr>
                            <tr data-dt-row="0" data-dt-column="3">
                                <td>
                                    <div className="tableTitle">
                                        <Trans desc="Eğitim">10716</Trans>
                                    </div>
                                </td>
                                <td className="showGrup">{t.training.name}</td>
                            </tr>
                            <tr data-dt-row="0" data-dt-column="4">
                                <td>
                                    <div className="tableTitle">
                                        <Trans desc="Katıldı">10715</Trans>
                                    </div>
                                </td>
                                <td className="showGrup">{t.isJoined ? i18n.t("10504") : i18n.t("10505")}</td>
                            </tr>
                            <tr data-dt-row="0" data-dt-column="5">
                                <td>
                                    <div className="tableTitle">
                                        <Trans desc="Başarı">10709</Trans>
                                    </div>
                                </td>
                                <td className="showGrup">
                                    {t.isSuccess ? i18n.t("10504") : i18n.t("10505")}
                                </td>
                            </tr>
                            <tr data-dt-row="0" data-dt-column="6">
                                <td>
                                    <div className="tableTitle">
                                        <Trans desc="Gün">10714</Trans>
                                    </div>
                                </td>
                                <td className="showGrup">
                                    {t.duration}
                                    <sup>
                                        <Trans desc="GÜN">10388</Trans>
                                    </sup>
                                </td>
                            </tr>
                            <tr data-dt-row="0" data-dt-column="7">
                                <td>
                                    <div className="tableTitle">
                                        <Trans desc="Eğitime Kayıtlı Mı">10717</Trans>
                                    </div>
                                </td>
                                <td className="showGrup">
                                    {t.isTrainingRegistered ? i18n.t("10504") : i18n.t("10505")}
                                </td>
                            </tr>
                            <tr data-dt-row="0" data-dt-column="8">
                                <td>
                                    <div className="tableTitle">
                                        <Trans desc="Eğitim alanı">10718</Trans>
                                    </div>
                                </td>
                                <td className="showGrup">{t.trainingArea[1033]}</td>
                            </tr>
                            <tr data-dt-row="0" data-dt-column="5">
                                <td>
                                    <div className="tableTitle">
                                        <Trans desc="Pozisyon Eğitim Türü">10722</Trans>
                                    </div>
                                </td>
                                <td className="showGrup">
                                    {t.positionTrainingTypes[this.languageCode].join(' - ')}
                                </td>
                            </tr>
                            {
                                this.props.isMechanical ?
                                    <tr data-dt-row="0" data-dt-column="8">
                                        <td>
                                            <div className="tableTitle">
                                                <Trans desc="Teknik pozisyon yükseltme eğitimleri">10727</Trans>
                                            </div>
                                        </td>
                                        <td className="showGrup">{t.technicalPositionPromotion != null ? t.technicalPositionPromotion.value == 1 ? i18n.t("10728") : i18n.t("10729") : "-"}</td>
                                    </tr> : null
                            }
                            <tr data-dt-row="0" data-dt-column="9">
                                <td>
                                    <div className="tableTitle">
                                        <Trans desc="Ağırlık">10719</Trans>
                                    </div>
                                </td>
                                <td className="showGrup">{t.weight != 0 && t.weight != null ? t.weight : "-"}</td>
                            </tr>
                            <tr data-dt-row="0" data-dt-column="10">
                                <td>
                                    <div className="tableTitle">
                                        <Trans desc="Gelecek Ağırlık">10720</Trans>
                                    </div>
                                </td>
                                <td className="showGrup">{t.futureWeight != 0 && t.futureWeight != null ? t.futureWeight : "-"}</td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        );
    };

    render() {
        const { t } = this.props;
        return (
            <>
                <DesktopBreakpoint>
                    <tr>
                        {this.renderTrainingMethodIcon(t.trainingMethod.value)}
                        <td className="showGrup">{t.training.name}</td>
                        <td className="showGrup">{t.isJoined ? i18n.t("10504") : i18n.t("10505")}</td>
                        <td className="showGrup">{t.isSuccess ? i18n.t("10504") : i18n.t("10505")}</td>
                        <td className="showGrup">{t.duration}
                            <sup>
                                <Trans desc="GÜN">10388</Trans>
                            </sup>
                        </td>
                        <td className="showGrup">{t.isTrainingRegistered ? i18n.t("10504") : i18n.t("10505")}</td>
                        <td className="showGrup">{t.trainingArea[1033]}</td>
                        <td className="showGrup">{t.positionTrainingTypes[this.languageCode].join(' - ')}</td>
                        {this.props.isMechanical ? <td className="showGrup">{t.technicalPositionPromotion != null ? t.technicalPositionPromotion.value == 1 ? i18n.t("10728") : i18n.t("10729") : "-"}</td> : null}
                        <td className="showGrup">{t.weight != 0 && t.weight != null ? t.weight : "-"}</td>
                        <td className="showGrup">{t.futureWeight != 0 && t.futureWeight != null ? t.futureWeight : "-"}</td>
                    </tr>
                </DesktopBreakpoint>
                <TabletBreakpoint>
                    <tr className={this.rowClassName} onClick={this.ToggleChildren}>
                        {this.renderTrainingMethodIcon(t.trainingMethod.value)}
                        <td className="showGrup">{t.training.name}</td>
                    </tr>
                    {this.renderTabletModeDetail(t)}
                </TabletBreakpoint>
            </>
        );
    }
}

export default EmployeeTraining;
